const templates =  {
    "shop.okraina.ru": {
        title: "Доставка",
        tags: [
            {
                name: "description",
                content: "Информаиця о доставке",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
    "dostavka.okraina.ru": {
        title: "Доставка",
        tags: [
            {
                name: "description",
                content: "Информаиця о доставке",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
}

export default templates;